var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","height":"calc(100vh - 48px)"}},[_c('mx-preloader',{attrs:{"loader-status":_vm.preloader}}),_c('v-container',{attrs:{"fluid":""}},[_c('NoticeList',{attrs:{"notices":_vm.notices}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }